module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "otx_color.168e4881.svg";